import { Divider } from '@rneui/base'
import { Icon, Text, makeStyles } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'

import { StoreRatingLifetime } from '@nextforce/api'

const MIN_SHIFT_RATING = 3.5

interface Props {
  ratingLifetime?: StoreRatingLifetime
}
export function StoreRatingView({ ratingLifetime }: Props) {
  const styles = useStyles()
  if (!ratingLifetime?.rating || ratingLifetime?.rating <= MIN_SHIFT_RATING) {
    return null
  }
  return (
    <View>
      <Divider style={styles.divider} />
      <View style={styles.rating}>
        <Text>{`Average shift rating : `}</Text>
        <Icon
          name={'star'}
          type="material-design"
          color={styles.icon.color}
          style={styles.icon}
        />
        <Text
          style={styles.ratingText}
        >{`${ratingLifetime?.rating} (${ratingLifetime?.ratingsCount} ratings)`}</Text>
      </View>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.colors.primary,
    margin: 5,
  },
  rating: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
  },
  ratingText: {
    color: theme.colors.primary,
  },
  divider: {
    backgroundColor: theme.colors?.grey4,
  },
}))
